import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type TrackProductQueryVariables = Types.Exact<{
  sku: Types.Scalars['String'];
}>;


export type TrackProductQuery = { __typename?: 'query_root', customer?: Types.Maybe<{ __typename?: 'CustomerMetadata', id: number, firstName?: Types.Maybe<string>, lastName?: Types.Maybe<string>, email?: Types.Maybe<string>, phone?: Types.Maybe<string> }>, items: Array<(
    { __typename?: 'items' }
    & TrackProductItemFragment
  )> };

export type TrackProductItemFragment = { __typename?: 'items', id: number, sku: string, name: string, properties?: Types.Maybe<any>, itemType: string, sellPriceInCents?: Types.Maybe<number>, tax?: Types.Maybe<{ __typename?: 'taxes', id: number, amount: any }> };

export const TrackProductItemFragmentDoc = gql`
    fragment TrackProductItem on items {
  id
  sku
  name
  properties
  itemType: item_type
  sellPriceInCents: sell_price_in_cents_excl_tax
  tax {
    id
    amount
  }
}
    `;
export const TrackProductDocument = gql`
    query trackProduct($sku: String!) {
  customer: nest_getCustomerMetadata {
    id
    firstName
    lastName
    email
    phone
  }
  items(where: {sku: {_eq: $sku}}, limit: 1) {
    ...TrackProductItem
  }
}
    ${TrackProductItemFragmentDoc}`;
export function useTrackProductQuery(baseOptions: Apollo.QueryHookOptions<TrackProductQuery, TrackProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackProductQuery, TrackProductQueryVariables>(TrackProductDocument, options);
      }
export function useTrackProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackProductQuery, TrackProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackProductQuery, TrackProductQueryVariables>(TrackProductDocument, options);
        }
export type TrackProductQueryHookResult = ReturnType<typeof useTrackProductQuery>;
export type TrackProductLazyQueryHookResult = ReturnType<typeof useTrackProductLazyQuery>;
export type TrackProductQueryResult = Apollo.QueryResult<TrackProductQuery, TrackProductQueryVariables>;